import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Phone, MessageCircle } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { optimizedImage } from "@/lib/image";

const BG_IMAGE = "https://customer-assets.emergentagent.com/job_maison-transition/artifacts/7htetnuv_photo%20boutique%20abd%20.jpeg";

const PhoneButton = ({ className, children }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button className={className}>{children}</button>
    </DropdownMenuTrigger>
    <DropdownMenuContent className="bg-white">
      <DropdownMenuItem asChild>
        <a href="tel:0608691129" className="flex items-center gap-2 cursor-pointer">
          <Phone className="w-4 h-4" /> Appeler
        </a>
      </DropdownMenuItem>
      <DropdownMenuItem asChild>
        <a href="sms:0608691129" className="flex items-center gap-2 cursor-pointer">
          <MessageCircle className="w-4 h-4" /> Envoyer un SMS
        </a>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

const RachatCashPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative flex flex-col overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 -z-10">
        <img
          src={optimizedImage(BG_IMAGE, { w: 1920, q: 75 })}
          alt="Au Bon Débarras - Boutique"
          className="w-full h-full object-cover"
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#4A3728]/75 via-[#4A3728]/65 to-[#4A3728]/85" />
      </div>

      {/* Header */}
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-white bg-[#4A3728]/70 hover:bg-[#4A3728] backdrop-blur-sm px-4 py-2 rounded-full transition-colors"
            data-testid="btn-retour"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="hidden sm:inline">Retour</span>
          </button>

          <PhoneButton className="flex items-center gap-2 text-white bg-[#4A3728]/70 hover:bg-[#4A3728] backdrop-blur-sm px-4 py-2 rounded-full font-medium transition-colors">
            <Phone className="w-4 h-4" />
            <span className="hidden sm:inline">06 08 69 11 29</span>
          </PhoneButton>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center relative z-10 px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl text-center"
        >
          <h1 className="font-serif text-7xl md:text-9xl text-white mb-10 tracking-tight">
            Rachat Cash
          </h1>

          <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-12 max-w-2xl mx-auto">
            Sur RDV en boutique ou à votre domicile, nous vous proposons de vous racheter vos objets, bijoux, montres, etc...
          </p>

          <PhoneButton className="inline-flex items-center gap-2 bg-[#D97706] hover:bg-[#b96305] text-white rounded-full px-8 py-4 text-lg font-medium transition-all duration-300 hover:scale-105 shadow-lg">
            <Phone className="w-5 h-5" />
            Nous contacter
          </PhoneButton>
        </motion.div>
      </div>

      <div className="py-8 text-center relative z-10">
        <p className="text-white/50 text-sm">
          Au Bon Débarras | 102 Av. du Passous, 50230 Agon-Coutainville
        </p>
        <p className="text-white/40 text-sm mt-1 select-text">
          aubondebarras1@gmail.com
        </p>
      </div>
    </div>
  );
};

export default RachatCashPage;
